import { cva, VariantProps } from 'class-variance-authority'
import { CSSProperties, forwardRef, ReactNode } from 'react'

import { cn } from '@/ui/utils/style'

export interface PanelProps extends VariantProps<typeof panelVariants> {
  children?: ReactNode
  className?: string
  style?: CSSProperties
  'data-testid'?: string
}

export const Panel = forwardRef<HTMLDivElement, PanelProps>(
  ({ children, 'data-testid': dataTestId, className, style, ...variants }, ref) => {
    return (
      <section className={cn(panelVariants(variants), className)} ref={ref} data-testid={dataTestId} style={style}>
        {children}
      </section>
    )
  },
)
Panel.displayName = 'Panel'

const panelVariants = cva('rounded-sm', {
  variants: {
    variant: {
      primary: 'bg-primary text-primary',
      secondary: 'bg-primary-inverse text-primary-inverse',
      tertiary: 'bg-tertiary text-primary',
      quaternary: 'bg-fg-primary text-primary-inverse',
    },
    spacing: {
      none: 'p-0',
      xs: 'p-2 sm:p-3 md:p-4',
      s: 'p-3 sm:p-4 md:p-6',
      m: 'p-4 sm:p-5 md:p-8',
      l: 'p-5 sm:p-7 md:p-10',
    },
  },
  defaultVariants: {
    variant: 'primary',
    spacing: 'm',
  },
})
